<template>
	<div :class="variantCls.root">
		<select
			:class="variantCls.select"
			:disabled="disabled"
			@change="emit('input', $event.target.value)"
			@focus="emit('focus')"
			@blur="emit('blur')"
		>
			<option v-if="allowSelectNothing" :value="null">{{ placeholder }}</option>
			<option v-else-if="!iPhone" :value="null" disabled selected hidden>{{ placeholder }}</option>
			<option
				v-for="(option, i) in options"
				:key="i"
				:selected="option[valueKey] === value"
				:value="option[valueKey]"
				:disabled="option.disabled"
			>
				{{ option[nameKey] }}
			</option>
		</select>
		<div :class="variantCls.iconRoot">
			<slot name="icon" :variantCls="variantCls">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 292 292" :class="variantCls.icon">
					<path
						d="M287 69.4a17.6 17.6 0 0 0-13-5.4H18.4c-5 0-9.3 1.8-12.9 5.4A17.6 17.6 0 0 0 0 82.2c0 5 1.8 9.3 5.4 12.9l128 127.9c3.6 3.6 7.8 5.4 12.8 5.4s9.2-1.8 12.8-5.4L287 95c3.5-3.5 5.4-7.8 5.4-12.8 0-5-1.9-9.2-5.5-12.8z"
					></path>
				</svg>
			</slot>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		variant: {
			type: String,
			default: "default"
		},
		value: {
			required: true,
			default: "",
			validator(val) {
				return val === null || typeof val === "string" || typeof val === "number"
			}
		},
		disabled: {
			type: Boolean,
			default: false
		},
		options: {
			required: true,
			default: () => [],
			type: Array
		},
		nameKey: {
			type: String,
			default: "name"
		},
		valueKey: {
			type: String,
			default: "value"
		},
		placeholder: {
			type: String,
			default: "----"
		},
		allowSelectNothing: {
			type: Boolean,
			required: false,
			default: true
		}
	},
	computed: {
		variantCls() {
			return this.$store.getters.variants("JSelect", this.variant).el
		},
		iPhone() {
			if (process.browser) {
				return navigator.platform.includes("iPhone") || navigator.platform.includes("iPod")
			}

			return false
		}
	},
	methods: {
		emit(...args) {
			if (!this.disabled) {
				this.$emit(...args)
			}
		}
	}
}
</script>
